import API from "../api";
import _ from "lodash";
import store from "../store";

// Function help to verify the token is valid
const verifyAccessToken = async (token) => {
    try {
        // eslint-disable-next-line no-unused-vars
        const response = API.post('/authentication/verify/', {token: token})
        .then(res => {
            return _.isEmpty(res.data);
        }).catch(rse => {
            return false;
        });
    } catch (error) {
        return false;
    }
};

//Function help to check user is authenticated?
const isAuthenticated = () => {
    const authState = store.getState().auth;
    if (authState && authState.isAuthenticated === true) {
        const token = authState.access_token;
        return verifyAccessToken(token);
    }
    return false;
};

//Function help to check user has access based on an array roles?
const hasPermission = (requiredRoles) => {
    const authState = store.getState().auth;
    if (authState && authState.isAuthenticated === true) {
        const userRole = authState.user.role;
        return requiredRoles.includes(userRole);
    }
    return false
};

export {
    verifyAccessToken,
    isAuthenticated,
    hasPermission
}